export default __webpack_public_path__ + "static/media/bsn.8808f8a6.svg";